<template>
  <div>
    <div class="flex flex-col gap-8 md:gap-6">
      <div id="memberBenefits" class="scroll-mt-[60px] md:scroll-mt-4">
        <PanelTitle v-bind="membershipPanelTitle" :isTitleRichText="true" />
      </div>
      <PromoCardMiniList
        :bindings="membershipBenefits"
        :promoCards="membershipBenefits.fields"
        :heading="membershipBenefits.heading"
        :cardLayout="membershipBenefits.cardLayout"
        :maxItemsToShow="membershipBenefits.maxItemsToShow"
      />
      <RichText class="racq-max-w-xl5" :field="membershipBenefitsDisclaimer.label" />
      <Divider outerClass="!my-12 mb-20" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { ISitecoreFormGenericInput } from '@/interfaces';
import { onMounted, ref } from 'vue';
import { getFormInput } from '@/utils/form-input-helper';
import { useAccountStore } from '@/store';
import PromoCardMiniList from '@/components/PromoCardMini/PromoCardMiniList.vue';
import PanelTitle from '@/components/PanelTitle/PanelTitle.vue';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import Divider from '@/components/Divider/Divider.vue';
import { useI18n } from 'vue-i18n';
import { PageAnalyticsBuilder } from '@/utils/page-analytics-builder';

const props = defineProps<{
  content: ISitecoreFormGenericInput[];
  id: string;
  name: string;
}>();

const accountStore = useAccountStore();
const dictionary = useI18n().getLocaleMessage('en') as Record<string, string>;
const membershipBenefits = getFormInput(
  props.content,
  accountStore.identityDetails?.membershipLoyalty?.toLowerCase() + 'MemberPromoCardMiniList'
);
const membershipBenefitsDisclaimer = getFormInput(
  props.content,
  accountStore.identityDetails?.membershipLoyalty?.toLowerCase() + 'MemberDisclaimer'
);

const membershipLoyaltyLevel = ref<string>(accountStore.identityDetails?.membershipLoyalty ?? '');

const membershipPanelTitle = {
  ...getFormInput(props.content, 'memberPanelTitle'),
  title: {
    value: `<span class='text-member-${membershipLoyaltyLevel?.value.toLowerCase()}'>${membershipLoyaltyLevel.value} member</span> benefits<sup>†</sup>`,
  },
};

onMounted(() => {
  pushAnalytics();
});

const pushAnalytics = async () => {
  const pageAnalytics = new PageAnalyticsBuilder();
  pageAnalytics.populateProducts(dictionary);
  pageAnalytics.pushAnalytics();
};
</script>
